<table [ngClass]="tableClass" class="table table-border round-corner">
  <thead>
    <tr>
      <th scope="col" class="text-center" width="40" [ngSwitch]="headerCheckboxState">
        <fa-icon class="fa-lg mr-1" (click)="setCheckAll()" [icon]="['fal','square']"
          *ngSwitchCase="checkboxState.Unchecked"></fa-icon>
        <fa-icon class="fa-lg mr-1" (click)="setNotCheckAll()" [icon]="['fas','check-square']"
          *ngSwitchCase="checkboxState.Checked"></fa-icon>
        <fa-icon class="fa-lg mr-1" (click)="setCheckAll()" [icon]="['fas','minus-square']"
          *ngSwitchCase="checkboxState.Indeterminate"></fa-icon>
      </th>
      <th class="text-left" scope="col" *ngFor="let header of headersTable" width="{{ header.width }}">
        {{ header.title | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of data" [ngClass]="{'row-success': item.checked == true }">
      <td width="35" class="text-center" (click)="selectedItem(item)">
        <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngIf="!item.checked"></fa-icon>
        <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngIf="item.checked"></fa-icon>
      </td>

      <ng-container *ngFor="let element of item | keyvalue: returnZero">
        <td *ngIf="((''+element.key !== 'checked') && (!isBoolean(element.value)) && (findField(element.key)))">
          <ng-container *ngIf="isSubscriberTypeRoleField(element.key); else defaultGridCell">
            {{ (element.value | translate) || '-' }}
            <cdx-tag class="ml-2" [options]="inactiveTag" *ngIf="showSignatoryTypeRoleInactiveTag(item)"></cdx-tag>
          </ng-container>
          <ng-template #defaultGridCell>
            {{ element.value | translate }}
          </ng-template>
        </td>
        <td
          *ngIf="((''+element.key !== 'checked') && (''+element.key !== 'isSignFree') && (isBoolean(element.value) && findField(element.key)))">
          {{element.value == true ? ('active'| translate) : ('inactive'| translate)}}
        </td>
      </ng-container>
    </tr>

  </tbody>
</table>
